import React from "react";
import ArtistSingleImages from "../components/ArtistImages/ArtistSingleImage";
import flyerImage from "../assets/flyers/CT.jpg";
import "./Curriculum.css"; // Reusing Curriculum styles for the table

const About = () => {
  return (
    <div className="about-page">
      {/* Image Section */}
      <ArtistSingleImages />

      {/* Text Section */}
      <section className="page-section about-section">
        <p>
          Seattle Raman, as he is popularly known to South Indian Carnatic musicians, 
          young and old, has been engaged in the promotion of Carnatic music for 
          the past 25 years. He has sponsored, organized, and hosted all 
          the senior vocal artists in Seattle, Washington, USA, for the past twenty-five 
          years. He is the past director of the non-profit music organization, Ragamala, 
          for twenty-five years. He was also the chairman of the non-profit organization, 
          'ACME' (Academy for Carnatic Music Education and Dance) and was engaged in singing, 
          teaching and conducting workshops on Trinities, conducting
          Sri.Thyagaraja Music Festival in Seattle, Washington for over 25 years.
        </p>

        <p>
          Raman hails from a great musical family. He had his initial tutelage from his 
          grandmother Seethammal, who was a great vocalist and a talented Veena player. From a very 
          young age, Raman was exposed to Carnatic music. After a lapse of many years 
          during his study period in the USA, Raman started learning in earnest from Shri. B. 
          Rajam Iyer (Senior disciple of Ariyakudi Ramanuja Iyengar) and later from many 
          other senior vocal musicians. During the past twenty years, Raman had the benefit 
          of listening to and learning from all these 
          artists. He has imbibed the traditional values of Carnatic music from all the 
          senior vocal musicians, including the Shri. Madurai Mani Iyer bani as rendered by Shri. T.V. 
          Sankaranarayanan, the Shri. D.K. Pattammal bani as rendered by Shri. Lalitha Sivakumar, 
          Shri. O.S. Thiagarajan, Shri. P. Unnikrishnan, and Shri. R. Suryaprakash.
        </p>

        <div className="concert-flyer">
          <img
            src={flyerImage}
            alt="Concert Flyer"
            className="flyer-image"
          />
        </div>



        <p> 
          After retiring from his professional career, Raman has dedicated himself fully
          to singing, teaching, and performing vocal concerts both in the United States 
          and in Chennai, Tamil Nadu. He has given over 95 concerts at various venues across 
          Chennai, India, Singapore, and the USA. A partial list of these venues can be found 
          below. Since the 1970s, Raman has trained under several esteemed gurus, including 
          Shri B. Rajam Iyer, Smt. Lalitha Sivakumar (mother of Nityashree Mahadevan), 
          Shri O.S. Thiagarajan, Shri P. Unnikrishnan, and Shri R. Suryaprakash. 
        </p>
        <p> 
          Raman teaches Carnatic Classical, Carnatic Light Music, Prayer Bhajans and 
          Thyagaraja Pancharatna Kritis, to young and older students under the auspices
          of Shrutilaya Fine Arts.
        </p>

        {/* Concert List Table */}
        <h2>Partial List of Concerts</h2>
        <table className="curriculum-table">
          <thead>
            <tr>
              <th>Region</th>
              <th>Concert Venues</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>India</td>
              <td>
                <ul>
                  <li>Sri Thyagaraja Sangeet Vidwat Samajam</li>
                  <li>Sri Thyagaraja Utsavam, Tiruvarur</li>
                  <li>Chennayil Thiruvaiyaru</li>
                  <li>Ananya Trust, Bengaluru, Karnataka</li>
                  <li>Sringeri Sharada Temple, Sringeri, Karnataka</li>
                  <li>Sri Udipi Krishna Temple, Udipi, Karnataka</li>
                  <li>Nataraja Temple, Chidambaram (Sivaratri Day)</li>
                  <li>Tamil Isai Sangam</li>
                  <li>Nada Inbam, Raga Sudha</li>
                  <li>Hamsadhwani</li>
                  <li>Guruvayur Temple, Guruvayur, Kerala</li>
                  <li>Sriranjani Trust</li>
                  <li>Bhrama Gana Sabha</li>
                  <li>Chennai Sangamam</li>
                  <li>Music Education Trust</li>
                  <li>Bairavi Music Circle, Pondicherry</li>
                  <li>Tiruvanmayur Asthika Samajam</li>
                  <li>Sri Panchamukhi Anjaneya Temple</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>Singapore</td>
              <td>
                <ul>
                  <li>Sri Murugan Temple</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>USA</td>
              <td>
                <ul>
                  <li>Ragamala, Seattle</li>
                  <li>HTCC Temple, Seattle</li>
                  <li>ISKCON Temple, Seattle</li>
                  <li>NW Folk Life Festival, Seattle</li>
                  <li>Livermore Temple, California</li>
                  <li>Siva Vishnu Temple, Maryland</li>
                  <li>Venkateswara Temple, Pomona, NY</li>
                  <li>Sri Venkateswara Temple, Oklahoma</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>

        
      </section>
    </div>
  );
};

export default About;
